import utils from '../../services/utils';

const route = [
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('authenticated.placeOrder', {
      url: 'orders/place',
      component: 'tctOrders',
      resolve: {
        canViewModule: ['actionsFactory',
          '$ngRedux',
          (actionsFactory, $ngRedux) => {
            const state = $ngRedux.getState();
            const user = state.authentication && state.authentication.user;
            if (utils.isLoggedInUserOfType(user, ['buyer',
              'master',
              'director',
            ])) {
              $ngRedux.dispatch(actionsFactory.state('authenticated.orders'));
            }
          }],
      },
    });
  },
];

export { route as default };
